<template>
  <div class="sale-net">
    <div class="sale-net-input">
      <span class="trend-title">组态地址</span>
      <el-input type="text" placeholder="请录入组态页面地址" v-model="address"></el-input>
    </div>
    <div class="last-save">
      <el-button :loading="interLoading" size="small" @click="saveInter" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data(){
    return{
      linshiID:'',
      interLoading:false,//加载状态
      address:'',
    }
  },
  mounted(){
    this.getInter()
  },
  methods:{
    //保存数据
    saveInter(){
      this.interLoading = true;
      let obj ={}
      if(this.linshiID){
        obj.id = this.linshiID
      }
      obj.confUrl = this.address
      api.saveConfig(obj).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.interLoading = false;
        }else{
          this.$message.error(res.message);
          this.interLoading = false;
          return;
        }
      })
    },
    //获取数据
    getInter(){
      api.getConfig().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.address = res.data.list[0].confUrl
            this.linshiID = res.data.list[0].id
          }
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.sale-net{ padding-top: 10px;
  .el-input{ width:50rem;}
}
</style>